import React, { useState } from 'react';
import { connect } from 'react-redux';

import TextField from '@material-ui/core/TextField';

import Toggle from '../../../../../../../components/Toggle';

import { changeFilters, getNFList } from '../../../../../../../redux/tracking';
import { updateCustomerUser } from '../../../../../../../redux/tracking-manager';

import { S } from './styles';
import { CompanyField } from '../NewRecipientForm/styles';
import { cpfOrCnpjMask } from '../../../../NFFilters/masks';

const EditRecipientForm = ({
  onClose,
  dispatch,
  currentPage,
  currentCustomer,
  currentUser,
  currentNameCompany,
}) => {
  const [name, setName] = useState(currentUser.Name);
  const [email, setEmail] = useState(currentUser.Email);
  const [phone, setPhone] = useState(currentUser.Phone);
  const [trackingActive, setTrackingActive] = useState(currentUser.HasTracking);

  const reloadPage = (currentPage) => {
    dispatch(changeFilters({ currentPage }));
    dispatch(getNFList());
  }

  const handleSubmit = () => {
    if ((name, email)) {
      dispatch(updateCustomerUser({
        id: currentUser.Id,
        name,
        email,
        phone,
        trackingActive,
        taxNumber: currentCustomer,
      }));

      onClose();
      reloadPage(currentPage);
    }
  };

  return (
    <S.FormContent>
      <S.FormTitle>Editar destinatário</S.FormTitle>

      <S.Form>
        <TextField
          placeholder="Nome*"
          value={name}
          onChange={e => {
            const value = e.target.value.replace(/[0-9]/g, "");
            setName(value);
          }}
          style={{ marginTop: '48px' }}
          required
          fullWidth
        />

        <TextField
          placeholder="E-mail*"
          fullWidth
          value={email}
          onChange={e => setEmail(e.target.value)}
          style={{ marginTop: '48px' }}
          required
        />

        <TextField
          placeholder="Telefone"
          value={phone}
          onChange={e => setPhone(e.target.value)}
          style={{ marginTop: '48px' }}
          fullWidth
          required
        />

        <CompanyField>
          <h4>
            {currentNameCompany}
          </h4>
          <span>
            {cpfOrCnpjMask(currentCustomer.trim())}
          </span>
        </CompanyField>

        <S.TrackingActiveContainer>
          <S.TrackingActive>Ativar/desativar rastreio</S.TrackingActive>
          <S.ToggleContainer>
            <Toggle
              isChecked={trackingActive}
              onChange={() => setTrackingActive(!trackingActive)}
              label={null}
              icon={null}
              small
            />
            <S.CheckBoxLabel checked={trackingActive}>
              Rastreio ativo
            </S.CheckBoxLabel>
          </S.ToggleContainer>
          <S.TrackingDisclaimer>
            Ao ser aprovado, seu destinatário estará com o rastreio ativado.
          </S.TrackingDisclaimer>
        </S.TrackingActiveContainer>
      </S.Form>

      <S.ActionButtonsContainer>
        <S.StyledButton onClick={onClose}>Cancelar</S.StyledButton>
        <S.StyledButton skin="primary" onClick={handleSubmit}>
          Salvar
        </S.StyledButton>
      </S.ActionButtonsContainer>
    </S.FormContent>
  );
};

function mapStateToProps(state) {
  return {
    currentPage: state.tracking.filters.currentPage,
  };
}

export default connect(mapStateToProps)(EditRecipientForm);
